module.exports = __webpack_public_path__ + "static/media/sanad_plus_motor.adf9a4ef.svg";